import React, { type FC } from "react"
import Accordion from "@components/Accordion"
import { Container } from "@components/styles"
import type { FaqProps } from "./types"
import { FaqWrapper, Content, AccordionWrapper } from "./styles"

const Faq: FC<FaqProps> = ({
    content,
    faqs
}) => {
    return <Container>
        <FaqWrapper>
            {content && <Content dangerouslySetInnerHTML={{ __html: content }} />}

            {faqs && <AccordionWrapper>
                <Accordion
                    items={faqs?.map((faq) => ({
                        title: faq.question,
                        content: faq.answer
                    }))}
                />
            </AccordionWrapper>}

        </FaqWrapper>
    </Container>
}

export default Faq
